<template>
  <div style="background-color: white; border-radius: 5px; margin-bottom: 5px">
    <el-table
      :data="tabel_list"
      :border="true"
      cell-class-name="cell_class_name"
      max-height="100%"
      header-cell-class-name="header_cell_name"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <!-- <el-table-column type="index" label="序号"></el-table-column> -->
      <el-table-column prop="hospitalName" label="医院" width=""></el-table-column>
      <el-table-column prop="hospitalName" label="状态" width="100">
        <template scope="scope">
          <el-tag style="vertical-align: middle" size="mini" :type="scope.row.isReportedThisWeek ? 'success' : 'danger'">
            {{ scope.row.isReportedThisWeek ? '已填报' : '未填报' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template scope="scope">
          <el-link type="primary" @click="handleTb(scope.row)">
            <i class="el-icon-edit"></i>
            填报
          </el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { isExternal } from '@/../util/validate'

export default {
  name: 'Approve',
  data() {
    return {
      listLoading: false,
    }
  },
  props: ['ApproveList', 'SP_IF', 'tabel_list', 'actualMonth'],
  //   props: {
  //     ApproveList: {
  //       type: Object,
  //       default: {},
  //     },
  //   },
  computed: {},
  created() {},
  //   watch: {
  //     ApproveList() {
  //       this.ApproveListFn()
  //     },
  //   },
  methods: {
    handleTb(e) {
      this.$router.push({
        path: '/NVBP/mobile/cataractnnvmpMobile',
        query: {
          zcncode: e.zcnCode,
          id: e.ID,
          status: 'CK',
          back_url: '/NVBP/cataractnnvmp',
          actualMonth: this.actualMonth,
          //   hco_list: JSON.stringify(e),
        },
      })
      localStorage.removeItem('actualMonth')
      localStorage.setItem('hco_list', JSON.stringify(e))
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
}
</script>
